// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","navigation__item":"Navigation_navigation__item__6PW3O","navigation__img":"Navigation_navigation__img__Wv2I+"};